/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/HighlightedArticles/theme';

export const HighlightedArticlesTheme = theme;
